/* eslint-disable react/no-unused-state */
import React from "react";
import { Tag, Input } from "antd";
import { PlusOutlined } from "@ant-design/icons";

export default class TagsGroup extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      tags: props.tags || [],
      inputVisible: false,
      inputValue: "",
    };
  }

  handleClose = (removedTag) => {
    const tags = this.props.tags.filter((tag) => tag !== removedTag);
    this.setState({ tags });
    this.props.onTagChange(tags);
  };

  showInput = () => {
    this.setState({ inputVisible: true }, () => this.input.focus());
  };

  handleInputChange = (e) => {
    this.setState({ inputValue: e.target.value });
  };

  handleInputConfirm = () => {
    const { inputValue } = this.state;
    let { tags } = this.props;

    if (inputValue && tags.indexOf(inputValue) === -1) {
      tags = [...tags, inputValue];
    }

    this.setState({
      inputVisible: false,
      inputValue: "",
    });

    this.props.onTagChange(tags);
  };

  saveInputRef = (input) => {
    this.input = input;
  };

  forMap = (tag) => {
    const tagElem = (
      <Tag
        style={{ marginBottom: "7px" }}
        closable
        onClose={(e) => {
          e.preventDefault();
          this.handleClose(tag);
        }}
        color={this.props.color ? this.props.color : "default"}
      >
        {tag}
      </Tag>
    );
    return (
      <span key={tag} style={{ display: "inline-block" }}>
        {tagElem}
      </span>
    );
  };

  render() {
    const { inputVisible, inputValue } = this.state;
    const { tags } = this.props;

    const tagChild = tags.map(this.forMap);

    return (
      <span>
        <span style={{ marginBottom: 16 }}>{tagChild}</span>

        {inputVisible && (
          <Input
            ref={this.saveInputRef}
            type="text"
            size="small"
            style={{ width: 78 }}
            value={inputValue}
            onChange={this.handleInputChange}
            onBlur={this.handleInputConfirm}
            onPressEnter={this.handleInputConfirm}
          />
        )}
        {!inputVisible && (
          <Tag onClick={this.showInput} className="site-tag-plus">
            <PlusOutlined />
          </Tag>
        )}
      </span>
    );
  }
}
